export function TimeUtil() {
  return {
    periods: {
      'minute' : 60000,
      'hour'   : 3.6e+6,
      'day'    : 8.64e+7,
      'week'   : 6.048e+8,
      '2week'  : 2 * 6.048e+8,
      'month'  : 2.62974e9,
      'quarter': 2.62974e9 * 4,
      'year'   : 3.156e+10,
      'all'    : 3.156e+12,
    },

    formats: [
      'HH:mm:ss', 'HH:mm', 'HH:mm',
      'EEE dd', 'dd EEE', 'MMM yyyy', 'MMM yyyy', 'yyyy',
    ],

    formatForRange: function (timeFrom, timeTo) {
      const ms = (timeTo.getTime() - timeFrom.getTime());
      let i = 0;
      angular.forEach(this.periods, function (value) {
        if (ms <= value) return;
        i++;
      });
      return this.formats[i];
    },
  };
}



// WEBPACK FOOTER //
// ./src/core/time-util.service.js